// PayDirt API — Feed endpoints

import { apiFetch } from './client';

export const fetchNewsArticles = () => apiFetch('/api/news/articles');
export const fetchRSSArticles = () => apiFetch('/api/news/rss');
export const fetchYouTubeFeed = () => apiFetch('/api/feed');
